<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Produtores" />
    <v-row>
      <v-col>
        <v-row justify="center">
          <v-col cols="12" md="3">
            <data-table-input-filter
              v-model="nameFilter.model"
              :filter="nameFilter"
              dense="compact"
            />
          </v-col>
          <v-col cols="12" md="3">
            <data-table-select-filter
              v-model="statusFilter.model"
              :filter="statusFilter"
              dense="compact"
            />
          </v-col>
        </v-row>
        <v-row justify="center" align="start">
          <template v-if="producers">
            <t-client-card
              v-for="producer in producers || []"
              v-show="isVisible(producer)"
              :key="producer.id"
              :producer="producer"
            />
          </template>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>

import { useProducerStore } from '@/stores/producer'
import TClientCard from './../../components/TClientCard.vue'
import TPageTitle from '@/components/TPageTitle.vue'
import DataTableSelectFilter from '@/components/datatable/DataTableSelectFilter.vue'
import DataTableInputFilter from '@/components/datatable/DataTableInputFilter.vue'
import { useSelectFilter } from '@/helpers/reports/selectFilter'
import { ref } from 'vue'
import { useTextFilter } from '@/helpers/reports/textFilter'
import Producer from '@/types/Producer'

const producers = useProducerStore().producers

const statusFilter = ref(
  useSelectFilter({
    label: 'Status',
    field: 'situacao',
    required: false,
    initial: 'active',
    items: [
      { title: 'Todos', value: '' },
      { title: 'Ativos', value: 'active' },
      { title: 'Inativos', value: 'inactive' },
    ],
    icon: '',
  }),
)

const nameFilter = ref(
  useTextFilter({ label: 'Nome', field: 'name', required: false }),
)

// Avoid recreating the cards every time the filters change
function isVisible(producer: Producer) {
  return producer.status.startsWith(statusFilter.value.value ?? '')
    && producer.data.trade_name.toLocaleLowerCase().includes((nameFilter.value.value ?? '').toLocaleLowerCase())
}
</script>
